module.exports = __webpack_public_path__ + "static/media/cbse2023.1f950c5f.jpeg";